// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"5f1294b9","98":"bfd4ee80","233":"8ccecd72","355":"9e10eb3c","377":"527100f7","392":"7db445c3","453":"ae890b73","455":"fb911264","576":"7684ae62","739":"186277ce","844":"458345b3","977":"5d37da8a"}[chunkId] + ".chunk.js";
};